module.exports = __webpack_public_path__ + "static/media/telecomunicaciones.bd32ff1f.png";